import voiceGateway from '../../voice-config/voiceGateway'

export function getVoiceGatewayConfig() {
  const raw = voiceGateway || {}
  const host = String(raw.host || '').replace(/\/$/, '')
  const path = raw.path ? String(raw.path) : '/ws'
  const proxyPath = raw.proxyPath ? String(raw.proxyPath) : '/voice-ws'
  const scheme = raw.scheme ? String(raw.scheme) : 'wss'
  const apiKey = String(raw.apiKey || '').trim()
  const debugScriptReleaseId = String(
    raw.debugScriptReleaseId != null ? raw.debugScriptReleaseId : '0',
  )
  const inputSampleRate = Number(raw.inputSampleRate) || 8000
  return {
    host,
    path,
    proxyPath,
    scheme,
    apiKey,
    debugScriptReleaseId,
    inputSampleRate,
  }
}

/** wss://tbig-model-debug.gooki.com/ws 或 wss://big-model-debug.gooki.com/ws */
export function getVoiceGatewayWsUrl() {
  const { scheme, host, path, apiKey } = getVoiceGatewayConfig()
  const qs = apiKey ? `?k=${encodeURIComponent(apiKey)}` : ''
  return `${scheme}://${host}${path}${qs}`
}

export function buildSessionUpdate({ scriptId, businessVars } = {}) {
  const { debugScriptReleaseId, inputSampleRate } = getVoiceGatewayConfig()
  const session = {
    script_id: String(scriptId != null && scriptId !== '' ? scriptId : ''),
    script_release_id: debugScriptReleaseId,
    input_sample_rate: inputSampleRate,
  }
  if (businessVars && typeof businessVars === 'object' && Object.keys(businessVars).length) {
    session.business_vars = businessVars
  }
  return { type: 'session.update', session }
}
